module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/Illustration_valuation-018f07e247a6c5bf09502e45b6c42304.svg";